/**
 * ნისია: the customer list and card, the customer and payment dialogs, the
 * payment-method picker they share with suppliers, and the bonus panel. The
 * debt reminder a customer RECEIVES (WhatsApp / SMS) is not here — it is a
 * message to the customer and stays Georgian (app/(app)/credit/page.tsx).
 */
export const credit = {
  'credit.noPhone': 'კლიენტს ტელეფონი არ აქვს მითითებული',
  'credit.copied': 'ტექსტი დაკოპირდა — ჩასვი SMS/Viber-ში',
  'credit.copyFailed': 'კოპირება ვერ მოხერხდა',
  'credit.deleted': 'კლიენტი წაიშალა',
  'credit.deleteTitle': 'კლიენტის წაშლა',
  'credit.deleteBody': 'ნამდვილად გსურთ წაშლა? შესაძლებელია მხოლოდ ბალანსის დახურვის შემდეგ; გაყიდვების ისტორია შენარჩუნდება, კლიენტთან კავშირი კი მოიხსნება.',
  'credit.totalDebt': 'ჯამური ვალი',
  'credit.searchPhone': 'სახელი ან ტელეფონი',
  'credit.search': 'კლიენტის ძებნა...',
  'credit.none': 'კლიენტი არ არის',
  'credit.settled': 'გასწორებული',
  'credit.owes': 'მართებს',
  'credit.weOwe': 'გვმართებს',
  'credit.prepaid': 'წინასწარ',
  'credit.takePayment': 'გადახდის მიღება',
  'credit.reminder': 'შეხსენება',
  'credit.waSend': 'WhatsApp-ით გაგზავნა',
  'credit.waSendTitle': 'WhatsApp-ში გაგზავნა',
  'credit.waReady': 'მზა ტექსტი, ნაშთით',
  'credit.noPhoneShort': 'ტელეფონი არ არის მითითებული',
  'credit.copyText': 'ტექსტის კოპირება',
  'credit.copyFor': 'SMS ან Viber-ისთვის',
  'credit.copyTitle': 'ტექსტის კოპირება (SMS/Viber-ისთვის)',
  'credit.copy': 'კოპირება',
  'credit.tabSales': 'ნისიით · {n}',
  'credit.tabPayments': 'გადახდები · {n}',
  'credit.salesTitle': 'ნისიით გაყიდვები',
  'credit.paymentsTitle': 'გადახდები',
  'credit.noSales': 'ნისიით გაყიდვა არ არის',
  'credit.noPayments': 'გადახდა არ არის',
  'credit.paidShort': 'გადახდ. {sum}',
  'credit.pickHint': 'აირჩიეთ კლიენტი დეტალების სანახავად',
  'credit.backToList': '← სია',
  'credit.currentDebt': '{name} — მიმდინარე ვალი: {sum}',

  'custDlg.nameRequired': 'სახელი სავალდებულოა',
  'custDlg.updated': 'კლიენტი განახლდა',
  'custDlg.added': 'კლიენტი დაემატა',
  'custDlg.editTitle': 'კლიენტის რედაქტირება',
  'custDlg.name': 'სახელი',
  'custDlg.namePh': 'მაგ. გიორგი ბერიძე',
  'custDlg.phone': 'ტელეფონი',
  'custDlg.company': 'კომპანია — ინვოისისთვის',
  // 1.58
  'custDlg.group': 'ფასის ჯგუფი',
  'custDlg.noGroup': 'ჯგუფის გარეშე — საცალო ფასი',
  'custDlg.groupHint': 'მოლარე ამ მყიდველს კალათაში აირჩევს და ფასები მისი ჯგუფით დაითვლება.',
  'custDlg.groupOwner': 'ჯგუფს მხოლოდ მფლობელი ცვლის.',
  'custDlg.legalName': 'იურიდიული დასახელება',
  'custDlg.legalNamePh': 'მაგ. შპს „მაგალითი"',
  'custDlg.tin': 'საიდენტიფიკაციო კოდი (ს/კ)',
  'custDlg.tinPh': '9 ან 11 ციფრი',
  'custDlg.legalAddress': 'იურიდიული მისამართი',
  'custDlg.addressPh': 'ქალაქი, ქუჩა',

  'pay.transfer': 'გადარიცხვა',
  'pay.form': 'გადახდის ფორმა',
  'pay.bankTerminal': 'ბანკის ტერმინალი',
  'pay.bankIn': 'რომელ ბანკში ჩაირიცხა',
  'pay.bankOut': 'რომელი ბანკიდან გადაირიცხა',
  'pay.otherBank': 'სხვა',
  'pay.enterAmount': 'შეიყვანეთ თანხა',
  'pay.pickBank': 'აირჩიე ბანკი',
  'pay.received': 'გადახდა მიღებულია: {sum}',
  'pay.overpay': 'თანხა ვალზე მეტია — სხვაობა ({sum}) წინასწარ გადახდად ჩაიწერება.',
  'pay.receiveBtn': 'მიღება — {sum}',

  'bonus.title': 'ბონუსი',
  'bonus.enterAmount': 'ჩაწერე თანხა, მაგ. 5 ან -2.50',
  'bonus.adjusted': 'ბონუსი შესწორდა — ბალანსი {sum}',
  'bonus.negative': 'უარყოფითი',
  'bonus.adjust': 'შესწორება',
  'bonus.empty': 'მოძრაობა ჯერ არ არის — ბონუსი პირველი ყიდვიდან დაერიცხება.',
  'bonus.adjustTitle': 'ბონუსის შესწორება',
  'bonus.adjustBody': '{name} · ახლა {sum}. დადებითი რიცხვი ამატებს (საჩუქარი), უარყოფითი აკლებს. ჩანაწერი ჟურნალში რჩება.',
  'bonus.amountPh': 'მაგ. 5 ან -2.50',
  'bonus.notePh': 'მიზეზი (არასავალდებულო)',
  // lib/loyalty BONUS_KIND_LABELS in the interface language; a test holds them equal
  'bonusKind.earn': 'დაერიცხა',
  'bonusKind.redeem': 'გამოიყენა',
  'bonusKind.return_earn': 'დაბრუნება — ჩამოეჭრა',
  'bonusKind.return_redeem': 'დაბრუნება — დაუბრუნდა',
  'bonusKind.adjust': 'კორექცია',
} as const
